import { useEffect, useState } from 'react';
import { useAuth } from "react-oidc-context";
import CampaignReport from './components/generate-report/CampaignReport';
import ScheduleReport from './components/schedule-report/ScheduleReport';
import { BrowserRouter as Router, Route, Routes, Navigate, NavLink } from "react-router-dom";

const sidebarItems = [
  { label: "Generate Report", path: "/generate-report", icon: "generate" },
  { label: "Schedule Report", path: "/schedule-report", icon: "schedule" },
];

const GenerateReportIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M7 4.5H14L18 8.5V19.5H7V4.5Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M14 4.5V8.5H18" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M9.5 12.5H15.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M9.5 15.5H13.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M9.5 9.5H11.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

const ScheduleReportIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="4" y="6" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.7" />
    <path d="M8 4V8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M16 4V8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M4 10H20" stroke="currentColor" strokeWidth="1.7" />
    <circle cx="12" cy="15" r="2.5" stroke="currentColor" strokeWidth="1.7" />
    <path d="M12 13.7V15L13 15.8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

const MenuIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M4 7H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M4 12H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M4 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

function App() {
  const auth = useAuth();
  const isLoggingOut = false;
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // Clean the URL after successful login
  useEffect(() => {
    if (auth.isAuthenticated && window.location.search.includes("code=")) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [auth.isAuthenticated]);
  console.log(auth.user)

  if (auth.isLoading || isLoggingOut) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  const protectedPage = (element) => {
    if (auth.isAuthenticated) return element;
    auth.signinRedirect();
    return null;
  };

  return (
    <Router>
      <div className="app-shell">
        {auth.isAuthenticated && (
          <aside className={`left-sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
            <button
              type="button"
              className="sidebar-toggle"
              onClick={() => setIsSidebarCollapsed((prev) => !prev)}
              aria-label={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              <MenuIcon />
            </button>

            {sidebarItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `sidebar-item ${isActive ? "active" : ""}`}
                title={item.label}
              >
                {item.icon === "schedule" ? <ScheduleReportIcon /> : <GenerateReportIcon />}
                {!isSidebarCollapsed && <span>{item.label}</span>}
              </NavLink>
            ))}
          </aside>
        )}

        <div className="app-content">
        {auth.isAuthenticated && (
          <header className="app-header">
            <div className="app-header-spacer" />
            <h1 className="app-header-title">Campaign Report Generator</h1>
            <div className="app-header-user">
              <span>Hello, {auth.user?.profile.email
               ?.split('@')[0]?.split('.')[0]?.replace(/^./, c => c.toUpperCase())}</span>

            </div>
          </header>
        )}
        
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Navigate to="/generate-report" replace />} />
            <Route path="/generate-report" element={protectedPage(<CampaignReport />)} />
            <Route path="/schedule-report" element={protectedPage(<ScheduleReport />)} />
            <Route path="*" element={<Navigate to="/generate-report" replace />} />
          </Routes>
        </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
